"use client";

import Loading from "@homeinstead/icons/Loading";
import { Button } from "@homeinstead/ui/components/Button";

type InquirySubmitButtonProps = {
  isPending: boolean;
  label: string;
};

function InquirySubmitButton({ isPending, label }: InquirySubmitButtonProps) {
  return (
    <Button
      className="mt-2 h-12 w-full rounded-full"
      disabled={isPending}
      loading={isPending}
      type="submit"
      variant="friendly"
    >
      {isPending ? (
        <Loading className="h-8 w-8 fill-new-beginnings-base" />
      ) : (
        label
      )}
    </Button>
  );
}

export { InquirySubmitButton };
